import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { closeModal } from 'components/Modal';
import { bem } from 'helpers/class-name';

import messages from '../SkuMenuPage.messages';

const { block, element } = bem('disable-category-modal');

export const DISABLE_CATEGORY_MODAL_NAME = 'DisableCategoryModal';

function DisableCategoryModal({ categoryName, onConfirmDisable }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [isDisabling, setIsDisabling] = useState(false);

  const handleCancel = () => {
    if (!isDisabling) {
      dispatch(closeModal());
    }
  };

  const handleConfirm = async () => {
    if (isDisabling) {
      return;
    }

    setIsDisabling(true);
    try {
      await onConfirmDisable?.();
      dispatch(closeModal());
    } catch (error) {
      // The caller handles user feedback; keep modal open so the action can be retried.
    } finally {
      setIsDisabling(false);
    }
  };

  return (
    <div
      className={block()}
      role="dialog"
      aria-modal="true"
      aria-label={intl.formatMessage(messages.disableCategoryDialogLabel)}>
      <Confirm
        className={element('content')}
        title={
          <Message
            message={messages.disableCategoryConfirmTitle}
            values={{ categoryName, strong: chunks => <strong>{chunks}</strong> }}
          />
        }
        cancelNode={<Message message={messages.disableCategoryConfirmCancel} />}
        acceptNode={<Message message={messages.disableCategoryConfirmAction} />}
        acceptDisabled={isDisabling}
        acceptWaiting={isDisabling}
        onCancel={handleCancel}
        onRequestClose={handleCancel}
        onConfirm={handleConfirm}>
        <Message message={messages.disableCategoryConfirmDescription} />
      </Confirm>
    </div>
  );
}

DisableCategoryModal.propTypes = {
  categoryName: PropTypes.string,
  onConfirmDisable: PropTypes.func,
};

DisableCategoryModal.defaultProps = {
  categoryName: '',
};

export default DisableCategoryModal;
